/**
 * First paint in the right palette.
 *
 * This is the first import in `main.tsx`, so it runs before React and before
 * any other module of the bundle — without an inline script in `index.html`,
 * which the server's `script-src 'self'` policy blocks. It reads the cached
 * preference the theme module writes and nothing more; the system listener and
 * the per-device server preference are set up afterwards by `initTheme`.
 *
 * It must stay dependency-free: anything imported here is evaluated before the
 * theme is applied, and would move the first paint towards the wrong palette.
 */

export const THEME_STORAGE_KEY = 'relaii.theme'

/** Stamps the cached light/dark choice on the root element. `system` leaves it alone. */
export function applyStoredTheme(root: HTMLElement = document.documentElement): 'light' | 'dark' | null {
  let theme: string | null = null
  try {
    theme = window.localStorage.getItem(THEME_STORAGE_KEY)
  } catch {
    // Private browsing may refuse storage; the system palette is the answer then.
  }

  if (theme !== 'dark' && theme !== 'light') return null
  root.dataset.theme = theme
  return theme
}

if (typeof document !== 'undefined') applyStoredTheme()
